import PropTypes from 'prop-types';

import { DEBOUNCE_QUANTITY, QUANTITY_LIMIT } from '@/common/constants';
import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const QuantityDefaultProps = {
  ...BaseDefaultProps,
  context: null,
  debounceDelay: DEBOUNCE_QUANTITY,
  errors: null,
  max: QUANTITY_LIMIT,
  onChange: () => null,
  quantity: 1,
  readOnly: false,
  required: false,
  salesPackaging: 1,
  splitPackaging: false,
  tabIndex: 0,
  title: null,
  unit: null,
  updateOnChange: true,
  valid: false,
};

export const QuantityPropTypes = {
  ...BasePropTypes,
  context: PropTypes.string,
  debounceDelay: PropTypes.number,
  errors: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  max: PropTypes.number,
  onChange: PropTypes.func,
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  salesPackaging: PropTypes.number,
  splitPackaging: PropTypes.bool,
  tabIndex: PropTypes.number,
  title: PropTypes.string,
  unit: PropTypes.string,
  updateOnChange: PropTypes.bool,
  valid: PropTypes.bool,
};
